import { ref, onMounted, onUnmounted } from 'vue'
// 内联简单的工具函数，避免混合导入警告
// import { isOnline, getNetworkInfo } from '@/utils/pwa'

/**
 * 检查网络状态（内联函数，避免混合导入）
 */
function isOnline() {
  return navigator.onLine
}

/**
 * 获取网络状态信息（内联函数，避免混合导入）
 */
function getNetworkInfo() {
  if ('connection' in navigator) {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
    return {
      effectiveType: connection.effectiveType,
      downlink: connection.downlink,
      rtt: connection.rtt,
      saveData: connection.saveData
    }
  }
  return null
}

/**
 * 网络状态组合式API
 * @returns {Object} 网络相关状态和方法
 */
export function useNetwork() {
  const online = ref(isOnline())
  const networkInfo = ref(getNetworkInfo())
  const effectiveType = ref(networkInfo.value?.effectiveType || 'unknown')
  const downlink = ref(networkInfo.value?.downlink || 0)
  const rtt = ref(networkInfo.value?.rtt || 0)
  const saveData = ref(networkInfo.value?.saveData || false)

  // 更新网络信息
  const updateNetworkInfo = () => {
    const info = getNetworkInfo()
    networkInfo.value = info
    if (info) {
      effectiveType.value = info.effectiveType
      downlink.value = info.downlink
      rtt.value = info.rtt
      saveData.value = info.saveData
    }
  }

  // 网络状态变化处理
  const handleOnline = () => {
    online.value = true
    updateNetworkInfo()
  }

  const handleOffline = () => {
    online.value = false
  }

  // 网络连接变化处理
  const handleConnectionChange = () => {
    updateNetworkInfo()
  }

  onMounted(() => {
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)
    
    if ('connection' in navigator) {
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
      if (connection) {
        connection.addEventListener('change', handleConnectionChange)
      }
    }
  })

  onUnmounted(() => {
    window.removeEventListener('online', handleOnline)
    window.removeEventListener('offline', handleOffline)
    
    if ('connection' in navigator) {
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
      if (connection) {
        connection.removeEventListener('change', handleConnectionChange)
      }
    }
  })

  return {
    online,
    networkInfo,
    effectiveType,
    downlink,
    rtt,
    saveData,
    updateNetworkInfo
  }
}

